module.exports = __webpack_public_path__ + "img/EAEAEA_B6B6B6_CCCCCC_C4C4C4-256px.df04acf6.png";